import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-fact-input',
  templateUrl: './fact-input.component.html',
  styleUrls: ['./fact-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => FactInputComponent)
    }
  ]
})
export class FactInputComponent implements ControlValueAccessor {

  internalModel: Array<string> = [];

  private _touched = false;
  private _onChange = (v: any) => {};
  private _onTouched = (touched: boolean) => {};

  addItem(input: HTMLInputElement) {
    if (input.value) {
      this.internalModel.push(input.value);
      input.value = '';
      this.updateNgValue();
    }
  }

  removeItem(index) {
    this.internalModel.splice(index, 1);
    this.updateNgValue();
  }

  // add new item on keypress "enter"
  handleKeyPress(event: KeyboardEvent, input) {
    if (event.key === 'Enter' && event.code === 'Enter') {
      this.addItem(input);
    }
  }

  /**
   *
   * ng value accessor functions
   */
  writeValue(newVal) {
    this.internalModel = newVal || [];
  }

  registerOnChange(onChange) {
    this._onChange = onChange;
  }

  registerOnTouched(onTouched) {
    this._onTouched = onTouched;
  }


  private updateNgValue() {
    if (!this._touched) {
      this._touched = true;
      this._onTouched(this._touched);
    }
    this._onChange(this.internalModel);
  }

}
